import * as React from 'react';
import '../styles/critical.scss';
import {Header} from "./Header";
import {Footer} from "./Footer";

export const Layout = ({alternativePath ,lang , path , children}) => {

  return (
    <>
      <Header path={path} alternativePath={alternativePath} lang={lang}/>
      <main>
        { children}
      </main>
      <Footer lang={lang}/>
    </>
  );
};
